import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "getaroundCircleFilled"
const GetaroundCircleFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.688C17.695 1.688 22.313 6.305 22.313 12S17.694 22.313 12 22.313 1.688 17.694 1.688 12 6.305 1.688 12 1.688M16.044 6.012C14.505 6.012 12.966 5.98 11.428 6.02 10.053 6.056 8.99 6.68 8.328 7.902 7.9 8.69 7.798 9.541 7.926 10.421 8.066 11.37 8.481 12.174 9.246 12.776 9.936 13.32 10.742 13.53 11.611 13.554 11.886 13.562 12.167 13.591 12.429 13.662 12.915 13.793 13.31 14.062 13.495 14.555 13.759 15.261 13.455 16.061 12.763 16.393 11.99 16.765 11.212 16.74 10.465 16.306 10.1 16.094 9.867 15.776 9.764 15.366 9.754 15.324 9.744 15.28 9.729 15.224L7.898 15.42C8.045 16.552 8.615 17.369 9.608 17.892 10.511 18.368 11.48 18.455 12.477 18.314 13.068 18.229 13.621 18.035 14.108 17.692 15.084 17.008 15.477 16.046 15.442 14.886 15.42 14.193 15.204 13.58 14.679 13.105 14.52 12.96 14.341 12.838 14.172 12.705 14.18 12.695 14.186 12.682 14.194 12.675 15.444 11.61 15.722 9.757 15.188 8.341 15.144 8.222 15.087 8.174 14.954 8.177 14.573 8.187 14.193 8.18 13.814 8.18 13.555 8.177 13.292 8.177 12.997 8.177L13.07 8.28C13.624 8.94 13.759 9.695 13.52 10.506 13.021 12.215 11.014 12.188 10.254 11.328 9.884 10.908 9.714 10.418 9.689 9.868 9.644 8.837 10.264 7.59 11.828 7.635 12.778 7.661 13.729 7.642 14.68 7.636 14.79 7.635 14.91 7.607 15.007 7.557 15.601 7.25 15.945 6.746 16.121 6.12 16.13 6.089 16.122 6.056 16.122 6.019 16.09 6.018 16.067 6.013 16.044 6.013"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default GetaroundCircleFilledIcon
